// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Calendar__wrapper","headerText":"Calendar__header-text","text":"Calendar__text","save":"Calendar__save"};